module.exports = __webpack_public_path__ + "img/personal-info.24e4ebaf.svg";